import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

const { texts, colors } = getBaseTheme();

export const BarChartContainer = styled.div`
    margin: 0 auto;
    width: 70%;
    min-width: 240px;

    text {
        ${texts.sizes.l};
    }

    text.unselected_label {
        fill: ${colors.control.disabled.complementaryBackgroundColor};
    }

    rect.bar {
        opacity: 1;
    }

    rect.selected_bar {
        opacity: 1;
    }

    rect.unselected_bar {
        opacity: 0.4;
    }

    rect:hover {
        cursor: pointer;
        &:not(.selected) {
            opacity: 0.7;
        }
    }
`;
